// Canonical RPC method names, shared by the worker bootstrap and the host so
// the two ends never drift. HOST_METHODS are handled by the host (the worker
// calls them); WORKER_METHODS are handled by the worker (the host calls them).

export const HOST_METHODS = {
  commandsRegister: 'commands.register',
  commandsUnregister: 'commands.unregister',
  commandsExecute: 'commands.execute',
  windowShowMessage: 'window.showMessage',
  windowShowQuickPick: 'window.showQuickPick',
  viewsRegister: 'views.registerTreeDataProvider',
  viewsUnregister: 'views.unregister',
  permissionsQuery: 'permissions.query',
  permissionsRequest: 'permissions.request',
  fsRead: 'fs.read',
  editorGetActiveText: 'editor.getActiveText',
  editorRegisterFoldProvider: 'editor.registerFoldProvider',
  editorUnregisterFoldProvider: 'editor.unregisterFoldProvider',
  surfaceRegister: 'surface.register',
  surfaceUnregister: 'surface.unregister',
  viewsRegisterSurface: 'views.registerSurfaceView',
  viewsUnregisterSurface: 'views.unregisterSurfaceView',
  surfacePost: 'surface.post',
  windowShowModal: 'window.showModal',
} as const;

export const WORKER_METHODS = {
  commandInvoke: 'command.invoke',
  viewGetChildren: 'view.getChildren',
  lifecycleActivate: 'lifecycle.activate',
  lifecycleDeactivate: 'lifecycle.deactivate',
  surfaceDeliver: 'surface.deliver',
  editorGetFolds: 'editor.getFolds',
} as const;

/** One-way host-to-worker signals. */
export const EVENTS = {
  permissionsChanged: 'permissions.changed',
} as const;
